import { FormikErrors } from "formik";
import { isEmpty } from "lodash";
import React, { Fragment } from "react";
import { Message } from "semantic-ui-react";

type FormErrorsProps = {
  errors: FormikErrors<any>;
};
function FormErrors({ errors }: FormErrorsProps) {
  return (
    <Fragment>
      {!isEmpty(errors) && (
        <Message negative>{JSON.stringify(errors)});</Message>
      )}
    </Fragment>
  );
}

export default FormErrors;
